export default "__VITE_ASSET__DLlQC0Yz__"